if (window.TCMS?.language === 'de' && window.Check24) {
    const DEBUG_ENVS = ['integration', 'int', 'development', 'dev', 'staging'];
    const env = window.TCMS?.env;
    const isDebugEnv = DEBUG_ENVS.includes(env);

    const hasDebugParam =
        new URLSearchParams(window.location.search).get('debugVisits') === '1';

    const shouldReport = !isDebugEnv || hasDebugParam;

    const report = () => {
        if (!shouldReport) return;

        try {
            if (typeof Check24.setWireframeConfig === 'function') {
                Check24.setWireframeConfig({
                    productSlug: window.TCMS.loginApiProduct || 'package',
                });
            } else {
                console.warn('[Quick-Chips] setWireframeConfig not available');
            }

            const fn = Check24.quickchips?.reportVisit;
            if (typeof fn === 'function') {
                const p = fn();

                if (p?.then) {
                    p.then((info) => {
                        if (info !== undefined && hasDebugParam) {
                            console.log('[Quick-Chips] reportVisit succeeded, info:', info);
                        } else {
                            console.log('[Quick-Chips] reportVisit succeeded.');
                        }
                    }).catch((e) => {
                        console.error('[Quick-Chips] reportVisit error:', e);
                    });
                } else {
                    console.log('[Quick-Chips] reportVisit succeeded');
                }
            } else {
                console.warn('[Quick-Chips] quickchips.reportVisit not available');
            }
        } catch (e) {
            console.error('[Quick-Chips] unexpected error:', e);
        }
    };

    report();

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            report();
        }
    });
}
